import React from 'react';
import './style.css';
import LyoLoad from '../animation/LyoLoad';

export default function LoadingScreen() {
  return (
    <div className='loading-screen'>
        <LyoLoad />
    </div>
  )
}